import { EditorState } from '../types';

export const unselectItems = (state: EditorState): EditorState => {
  if (state.selectedItems.length === 0 && state.activeGroupId === null) {
    return state;
  }

  return {
    ...state,
    selectedItems: [],
    activeGroupId: null,
    inspectedGroupMemberId: null,
  };
};
